import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {color, flex, mb, ml, p, pr} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {FilterFooter} from "./filters/SearchFiltersFooter";
import {GenericFilter} from "./generic_filters/GenericFilter";

interface IOwnProps<TSearchFiltersForm extends {}> {
    searchFiltersConfig: ISearchFilters<TSearchFiltersForm>;
    searchFiltersCountBySlots?: Record<string, number>;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    onMobileCloseModal?: () => void;
    onMobileResetForm?: () => void;
    topContent?: React.ReactNode;
}

interface IProps extends IOwnProps<ISearchFiltersFormValues>, IFormProps<ISearchFiltersFormValues> {}

const MobileSearchFiltersC = (props: IProps) => {
    const theme = useTheme();

    const closeMobileModal = () => {
        props.setDesktopFilterBlendActive && props.setDesktopFilterBlendActive(false);
        props.onMobileCloseModal && props.onMobileCloseModal();
    };

    const submitMobileModal = (e: React.MouseEvent<HTMLElement>) => {
        closeMobileModal();
        props.onSubmit && props.onSubmit(e);
    };

    return (
        <div css={filtersHolder}>
            <div css={filtersScroller}>
                {props.topContent}
                {props.searchFiltersConfig.slots.map((filterSlot) => (
                    <div key={filterSlot.id} css={[p(2, 3)]}>
                        <Text as="div" variant="body_copy_2" css={[flex("center"), pr(1), mb(2)]}>
                            {filterSlot.label}

                            {props.searchFiltersCountBySlots?.[filterSlot.id] ? (
                                <span css={[ml(0.5), color(theme.colors.danger)]}>({props.searchFiltersCountBySlots?.[filterSlot.id]})</span>
                            ) : null}
                        </Text>
                        <div>
                            {filterSlot.filters.map((filter) => (
                                <GenericFilter key={filter.id} filter={filter} {...props.getFieldProps(filter.id)} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div css={mobileFiltersFooterWrapper}>
                <FilterFooter
                    onCancel={props.onMobileResetForm || (() => null)}
                    onSave={(e: React.MouseEvent<HTMLElement>) => {
                        submitMobileModal(e);
                    }}
                />
            </div>
        </div>
    );
};

export const MobileSearchFilters = form<ISearchFiltersFormValues, IProps>(MobileSearchFiltersC);

const filtersHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;

    @media (min-width: ${theme.breakpoints.md}) {
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        flex-grow: 1;
        flex-shrink: 1;
        width: 50%;
        height: unset;

        div:nth-of-type(3) {
            margin-right: 0;
        }
    }
`;

const filtersScroller = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        overflow: initial;
    }
`;

const mobileFiltersFooterWrapper = (theme: Theme) => css`
    width: 100%;
    display: block;
    padding: 0 2rem;

    @media (min-width: ${theme.breakpoints.md}) {
        display: none;
    }
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {color, flex, mb, ml, p, pr} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {FilterFooter} from "./filters/SearchFiltersFooter";
import {GenericFilter} from "./generic_filters/GenericFilter";

interface IOwnProps<TSearchFiltersForm extends {}> {
    searchFiltersConfig: ISearchFilters<TSearchFiltersForm>;
    searchFiltersCountBySlots?: Record<string, number>;
    setDesktopFilterBlendActive?: (isOpen: boolean) => void;
    onMobileCloseModal?: () => void;
    onMobileResetForm?: () => void;
    topContent?: React.ReactNode;
}

interface IProps extends IOwnProps<ISearchFiltersFormValues>, IFormProps<ISearchFiltersFormValues> {}

const MobileSearchFiltersC = (props: IProps) => {
    const theme = useTheme();

    const closeMobileModal = () => {
        props.setDesktopFilterBlendActive && props.setDesktopFilterBlendActive(false);
        props.onMobileCloseModal && props.onMobileCloseModal();
    };

    const submitMobileModal = (e: React.MouseEvent<HTMLElement>) => {
        closeMobileModal();
        props.onSubmit && props.onSubmit(e);
    };

    return (
        <div css={filtersHolder}>
            <div css={filtersScroller}>
                {props.topContent}
                {props.searchFiltersConfig.slots.map((filterSlot) => (
                    <div key={filterSlot.id} css={[p(2, 3)]}>
                        <Text as="div" variant="body_copy_2" css={[flex("center"), pr(1), mb(2)]}>
                            {filterSlot.label}

                            {props.searchFiltersCountBySlots?.[filterSlot.id] ? (
                                <span css={[ml(0.5), color(theme.colors.danger)]}>({props.searchFiltersCountBySlots?.[filterSlot.id]})</span>
                            ) : null}
                        </Text>
                        <div>
                            {filterSlot.filters.map((filter) => (
                                <GenericFilter key={filter.id} filter={filter} {...props.getFieldProps(filter.id)} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div css={mobileFiltersFooterWrapper}>
                <FilterFooter
                    onCancel={props.onMobileResetForm || (() => null)}
                    onSave={(e: React.MouseEvent<HTMLElement>) => {
                        submitMobileModal(e);
                    }}
                />
            </div>
        </div>
    );
};

export const MobileSearchFilters = form<ISearchFiltersFormValues, IProps>(MobileSearchFiltersC);

const filtersHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;

    @media (min-width: ${theme.breakpoints.md}) {
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        flex-grow: 1;
        flex-shrink: 1;
        width: 50%;
        height: unset;

        div:nth-of-type(3) {
            margin-right: 0;
        }
    }
`;

const filtersScroller = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        overflow: initial;
    }
`;

const mobileFiltersFooterWrapper = (theme: Theme) => css`
    width: 100%;
    display: block;
    padding: 0 2rem;

    @media (min-width: ${theme.breakpoints.md}) {
        display: none;
    }
`;
